// Starter-prompt content module (onboarding design D-Content, sketch
// `starter-prompt-chips.html`). A small constant set of concrete, B++-expressible
// starter prompts the `PromptBox` offers as fill-not-send suggestion chips on a
// player's first prompts, plus the surrounding microcopy. Copy MUST never reference
// own-colony UI that does not render (the omitted eggs counter, D-069), and the
// microcopy notes that a prompt spends the Beekeeper cooldown only when it is accepted
// (BEEKEEPER §5). A pure content module (no wire provenance), asserted by
// `starter-prompts.test.ts`; `Colony.tsx` passes it to `PromptBox`'s `starterPrompts`
// prop.

export interface StarterPrompt {
  /** The short chip label shown in the suggestion row. */
  label: string;
  /** The full prompt text a tap FILLS into the draft (never auto-sent), which the
   * player may edit before sending. */
  prompt: string;
}

/** 3–5 starter prompts (OQ2, finalized within the D-Content constraints). Each maps to
 * a concrete B++ behaviour: gather (`collect_nectar`), return-and-unload
 * (`return_to_hive` + `drop_nectar`), defend (`fight`), and scout
 * (`wander` + `dance`). None references the omitted eggs counter (D-069). */
export const STARTER_PROMPTS: readonly StarterPrompt[] = [
  {
    label: 'Gather nectar',
    prompt: 'Send idle bees out to gather nectar from the nearest flowers.',
  },
  {
    label: 'Come home when full',
    prompt: 'Come home and unload at the hive when carrying a full load of nectar.',
  },
  {
    label: 'Defend the hive',
    prompt: 'Defend the hive by fighting enemies that come close.',
  },
  {
    label: 'Scout the field',
    prompt: 'Send scouts out to explore the field and dance about what they find.',
  },
];

/** The uppercase hint that heads the suggestion row. */
export const STARTER_PROMPT_HINT = 'Try one to get started';

/** Surrounding microcopy (design D-Content): a prompt spends the Beekeeper cooldown
 * only when it is accepted, so trying a suggestion is cheap (BEEKEEPER §5). */
export const STARTER_PROMPT_MICROCOPY =
  "A prompt only spends your cooldown when it's accepted — a failed attempt costs nothing.";
